export const QA_ORG = "qa";
export const SCHEDULE_ORG = "schedule";
export const MENTAL_ORG = "mental";
export const SHORT_FOCUS_ORG = "short-focus";
export const MANAGER_TRAINING_ORG = "manager-training";
export const NEGOTIATION_ORG = "negotiation";
export const SMALL_ELITE_ORG = "small-elite";
export const FLAT_ORG = "flat-org";
export const EXPANSION_STRATEGY_ORG = "expansion-strategy";
export const INVESTMENT_COMMITTEE_ORG = "investment-committee";
